import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import {
  AVERAGE_SALES_TABLE_HEADERS_INDEXES,
  AVERAGE_SALES_TABLE_NUMBER_OF_SUBHEADERS_PER_HEADER,
} from '../../pages/reports/standard/StandardReportUtils';
import { darken } from '@material-ui/core/styles';
import {
  BACKGROUND_DARK,
  BORDER_DARK,
  CELL_LIGHT_COLOR, DARK_YELLOW_COLOR,
  LIGHT_GREY_COLOR,
  PRIMARY_COLOR,
} from '../../../const/color-const';
import Box from '@material-ui/core/Box';

const styles = (theme => ({
  buttonWrapper: {
    position: 'absolute',
    width: 120,
    height: 40,
    top: 0,
    '& button': {
      margin: 0,
      padding: 0,
      width: '100%',
      height: '100%',
      position: 'relative',
      fontSize: 13,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      border: `1px solid ${DARK_YELLOW_COLOR}`,
    },
  },
  tableContainer: {
    width: '100%',
    minWidth: '50vw',
    borderRadius: '12px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
    },
    boxShadow: theme.palette.type === 'light' ? `0 0 20px 0 ${LIGHT_GREY_COLOR}` : `0 0 20px 0 ${BORDER_DARK}`,
    '& thead': {
      background: PRIMARY_COLOR,
      '& th': {
        color: 'black',
      },
    },
    '& tbody': {
      '& tr:nth-child(odd)': {
        backgroundColor: theme.palette.type === 'light' ? CELL_LIGHT_COLOR : (BACKGROUND_DARK),
      },
      '& tr:nth-child(even)': {
        backgroundColor: theme.palette.type === 'light' ? 'white' : darken(BACKGROUND_DARK, 0.2),
      },
    },
  },
  cellHeader: {
    fontSize: '16px',
  },
  cellData: {
    height: '52px',
    border: theme.palette.type === 'light' ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255,255, .1)',
    '& button': {
      '& svg': {
        color: 'green',
      },
    },
  },
}));

function renderHeader(tableConfig, withSubheaders, classes) {
  if (withSubheaders) {
    return (
      <TableHead>
        <TableRow>
          {tableConfig.map((config, index) => {
            if (AVERAGE_SALES_TABLE_HEADERS_INDEXES.includes(index)) {
              return (
                <TableCell
                  key={index}
                  align="center"
                  style={{ borderBottom: index === 0 && 'none' }}
                  colSpan={index !== 0 ? AVERAGE_SALES_TABLE_NUMBER_OF_SUBHEADERS_PER_HEADER : 1}>
                  {index !== 0 && config.header}
                </TableCell>
              );
            }
            return <React.Fragment key={index} />;
          })}
        </TableRow>
        <TableRow>
          {tableConfig.map((config, index) => {
            if (config.subheader && index > 0) {
              return (
                <TableCell
                  key={index}
                  align="center">
                  {config.subheader}
                </TableCell>
              );
            }
            return (
              <TableCell
                style={{ borderTop: 'none' }}
                key={index}
                align="center">
                {config.header}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
  return (
    <TableHead>
      <TableRow>
        {tableConfig.map((config, index) => (
          <TableCell className={classes.cellHeader}
                     key={index}
                     align="center">
            {config.header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const RegularTable = (props) => {
  const { data, tableConfig, classes, withSubheaders, excelButton } = props;
  return (
    <Box display={'flex'} flexDirection={'column'}>
      {excelButton && <div className={classes.buttonWrapper}>{excelButton}</div>}
      <TableContainer className={`${classes.tableContainer} tableWrapper`}>
        <Table size="small">
          {renderHeader(tableConfig, withSubheaders, classes)}
          <TableBody>
            {data.map((dataItem, rowIndex) =>
              <TableRow
                key={rowIndex}>
                {tableConfig.map((config, cellIndex) =>
                  <TableCell className={classes.cellData}
                             padding={'none'}
                             align={'center'}
                             key={cellIndex}>
                    {typeof config.value === 'function' ? config.value(dataItem) : config.value || ''}
                  </TableCell>,
                )}
              </TableRow>,
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default withStyles(styles)(RegularTable);
